import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { gql } from 'apollo-boost';
import * as compose from 'lodash.flowright';


import SideProfileInfro from './side-profileInfo.component';
import Profile from './profile.component';
import Speciality from './speciality.compponent';
import WorkExperience from './work-experience.component';
import JopBosts from './job-posts.component';
import Actifities from './activities.component';
import Password from './change-password.component';
import Education from './education.component';
// styles , icons and images
import { Container, Row, Col, Tab, Nav , Modal} from 'react-bootstrap';
import './explore.style.css';

// this component respresents the Explore opportunities page
class ApplicantProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    callback = (dataFromChild) => {
        this.setState({userData : dataFromChild});
    }
    render() {
        return (
            <div>
            <Container className="pt-4 container-fluid-responsive m-h-100">
                <Row className="m-0">
                    <Col md={4} className="p-0">
                        <SideProfileInfro data={this.state.userData}/>
                    </Col>
                    <Col md={8} className="p-0">
                        <Tab.Container defaultActiveKey="first">
                            <Row className="m-0 pt-xs-4">
                                <Col sm={12} className="mb-2">
                                    <Nav variant="pills" id="left-tabs-example">
                                        <Nav.Item>
                                            <Nav.Link eventKey="first" className="mr-3 bg-transparent" style={{ outline: 'none' }}>
                                                <h6>Profile</h6>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="second" className="mr-3 bg-transparent" style={{ outline: 'none' }}>
                                                <h6>Job posts</h6>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="third" className="mr-3 bg-transparent" style={{ outline: 'none' }}>
                                                <h6>My activity</h6>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="forth" className="mr-3 bg-transparent" style={{ outline: 'none' }}>
                                                <h6>Password</h6>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col sm={12} id="tab-content-container">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="first">
                                            <Profile callBackProp={this.callback} />
                                            <Speciality />
                                            <WorkExperience />
                                            <Education />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="second" >
                                            <JopBosts />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="third">
                                            <Actifities />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="forth">
                                            <Password />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Col>
                </Row>
            </Container>
        </div>
        );
    }
}

export default withRouter(ApplicantProfile);